var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5816",
    "data-name": "Group 5816",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.344,
    height: 30.13,
    viewBox: "0 0 27.344 30.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    width: 27.344,
    height: 30.13,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5816-2",
    "data-name": "Group 5816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49602",
    "data-name": "Path 49602",
    d: "M1.876,12.73a11.031,11.031,0,0,1,1.74-5.536c1.874-2.86,5.7-5.562,11.354-5.562a13.436,13.436,0,0,1,11.646,6,10.6,10.6,0,0,1,1.585,5.1,8.49,8.49,0,0,0-4.271-1.121,8.729,8.729,0,0,0-4.31,1.121A12.208,12.208,0,0,0,15,11.622a11.944,11.944,0,0,0-4.584,1.108,8.705,8.705,0,0,0-4.446-1.082,7.173,7.173,0,0,0-4.1,1.082",
    transform: "translate(-1.308 -1.138)",
    fill: "#4cbd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49603",
    "data-name": "Path 49603",
    d: "M40.182,52.752H38.426a1.726,1.726,0,1,1,0-3.452.423.423,0,0,1,.273.091.815.815,0,0,0,1.151.03.455.455,0,0,1,.333-.121,1.726,1.726,0,1,1,0,3.452m-1.908-2.513a.778.778,0,0,0-.636.757.8.8,0,0,0,.787.787h1.756A.8.8,0,0,0,40.97,51a.754.754,0,0,0-.636-.757,1.793,1.793,0,0,1-2.059,0",
    transform: "translate(-25.587 -34.371)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49604",
    "data-name": "Path 49604",
    d: "M34.234,70.218H23.877A1.887,1.887,0,0,1,22,68.341a1.907,1.907,0,0,1,.939-1.635V63.163c0-3.664,3.149-5.663,6.117-5.663s6.117,1.968,6.117,5.663v3.543a1.883,1.883,0,0,1-.939,3.513M29.056,58.469c-2.513,0-5.178,1.665-5.178,4.724v3.846a.5.5,0,0,1-.3.454.933.933,0,0,0,.3,1.817H34.234a.943.943,0,0,0,.939-.939.908.908,0,0,0-.636-.878.466.466,0,0,1-.3-.454V63.163c0-3.058-2.665-4.694-5.178-4.694",
    transform: "translate(-15.338 -40.088)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49605",
    "data-name": "Path 49605",
    d: "M41.5,71.9h3.452v.636H41.5Zm0,2.513h1.12a.73.73,0,0,0,.454-.121.806.806,0,0,0,.3-.333,1.27,1.27,0,0,0,.121-.484.826.826,0,0,0-.121-.484.806.806,0,0,0-.3-.333.73.73,0,0,0-.454-.121H41.5v-.515h1.3a1.555,1.555,0,0,1,.757.182,1.069,1.069,0,0,1,.485.545,1.8,1.8,0,0,1,.182.818,1.4,1.4,0,0,1-.212.787,1.345,1.345,0,0,1-.575.515,1.977,1.977,0,0,1-.878.182H41.5v-.636m0-1.272h3.452v.636H41.5Zm1.09,1.787.727-.151,1.3,2.271h-.848Z",
    transform: "translate(-28.933 -50.128)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49606",
    "data-name": "Path 49606",
    d: "M27,35.269a.713.713,0,0,1-.242-.061,8.238,8.238,0,0,0-8.146,0,.465.465,0,0,1-.485,0,9.5,9.5,0,0,0-8.66,0,.413.413,0,0,1-.454,0,8.238,8.238,0,0,0-8.146,0,.451.451,0,0,1-.636-.151.451.451,0,0,1,.151-.636A9.2,9.2,0,0,1,9.251,34.3a10.379,10.379,0,0,1,9.115,0,9.3,9.3,0,0,1,8.842.121.46.46,0,0,1,.182.636.434.434,0,0,1-.394.212",
    transform: "translate(-0.106 -23.157)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49607",
    "data-name": "Path 49607",
    d: "M44.185,37.985A.478.478,0,0,1,43.7,37.5V34.685a.485.485,0,0,1,.969,0V37.5a.52.52,0,0,1-.485.485",
    transform: "translate(-30.467 -23.844)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49608",
    "data-name": "Path 49608",
    d: "M28.867,19.151a.459.459,0,0,1-.454-.394,12.307,12.307,0,0,1,1.877-8.448.483.483,0,1,1,.818.515,11.136,11.136,0,0,0-1.756,7.782.5.5,0,0,1-.394.545c-.061-.03-.061,0-.091,0",
    transform: "translate(-19.723 -7.039)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49609",
    "data-name": "Path 49609",
    d: "M55.02,19.1H54.96a.462.462,0,0,1-.394-.545,10.949,10.949,0,0,0-1.756-7.782.483.483,0,1,1,.818-.515A12.112,12.112,0,0,1,55.5,18.71a.491.491,0,0,1-.485.394",
    transform: "translate(-36.761 -6.991)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49610",
    "data-name": "Path 49610",
    d: "M26.89,12.113a.478.478,0,0,1-.485-.484c0-5.9-5.693-10.689-12.718-10.689S.969,5.723.969,11.628a.478.478,0,0,1-.485.484A.478.478,0,0,1,0,11.628C0,5.208,6.117,0,13.657,0S27.314,5.208,27.314,11.628a.4.4,0,0,1-.424.484",
    fill: "#3d3d3d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyInvestment);
export default __webpack_public_path__ + "static/media/policy-investment.cd0748c8c2685c0d1c4c0c7906a5ca77.svg";
export { ForwardRef as ReactComponent };